<template>
  <div class="base-tab-list" :class="{ 'base-tab-list--full-width': fullWidth }">
    <div ref="tablistRef" role="tablist" class="base-tab-list__tabs">
      <button
        v-for="(tab, index) in tabList"
        :id="`base-tab-list-tab-${tab.id}`"
        :key="`base-tab-list-tab-${tab.id}`"
        role="tab"
        class="base-tab-list__tabs-button"
        :aria-selected="activeTab === index"
        :aria-controls="`base-tab-list-panel-${tab.id}`"
        :class="activeTab === index && 'base-tab-list__tabs-button--active'"
        :tabindex="activeTab === index ? 0 : -1"
        @click="activeTab = index"
        @keydown="handleTabKeydown"
      >
        {{ tab.label }}
      </button>
    </div>

    <div
      v-for="(tab, index) in tabList"
      v-show="activeTab === index"
      :id="`base-tab-list-panel-${tab.id}`"
      :key="tab.id"
      :aria-labelledby="`base-tab-list-tab-${tab.id}`"
      role="tabpanel"
      class="base-tab-list__tabpanel"
    >
      <slot :name="tab.slotName" :is-active="activeTab === index" />
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue';

const props = defineProps({
  tabs: {
    type: Array,
    required: true,
  },
  fullWidth: {
    type: Boolean,
    default: false,
  },
});

const activeTab = ref(0);
const tablistRef = ref(null);

const tabList = computed(() => {
  return props.tabs?.map((tab) => ({
    label: tab.label,
    id: tab.slotName,
    slotName: tab.slotName,
  }));
});

const handleTabKeydown = (e) => {
  if (e.key === 'ArrowRight') {
    if (activeTab.value === tabList.value.length - 1) {
      activeTab.value = 0;
      tablistRef.value?.children?.[0].focus();
    } else {
      activeTab.value = activeTab.value + 1;
      tablistRef.value?.children?.[activeTab.value].focus();
    }
  } else if (e.key === 'ArrowLeft') {
    if (activeTab.value === 0) {
      activeTab.value = tabList.value.length - 1;
      tablistRef.value?.children?.[tabList.value.length - 1].focus();
    } else {
      activeTab.value = activeTab.value - 1;
      tablistRef.value?.children?.[activeTab.value].focus();
    }
  }
};
</script>

<style lang="scss">
@import './scss/BaseTabList.scss';
</style>
